import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import { Styled } from './Loader.styles';
const Loader = () => {
    return (React.createElement(Styled.Loader, null,
        React.createElement(TailSpin, { width: 50, height: 50, color: "#0087f7", ariaLabel: "loading" })));
};
export default Loader;
